if (document.getElementById('product-page-articles-list-container')){

  const product_handle = window.shop.relatedArticles.product_handle;
  // const related_article_title = window.shop.relatedArticles.related_article_title;

  const blogs = [`https://www.tupperware.com.au/blogs/news/tagged/${product_handle}?view=json`, `https://www.tupperware.com.au/blogs/recipes/tagged/${product_handle}?view=json`];

    Promise.all(blogs.map(blog => fetch(blog).then(
      response => response.json()
    )))
    .then(jsonArray => {
      const data = jsonArray.concat.apply([],jsonArray);
      console.log("JSON ARR:",jsonArray.concat.apply([], jsonArray));
      getArticles(data); 
    })
    .catch(function(error) {
      console.log(error);
    });

  const getArticles = (article) => {
    let mainContainer = document.getElementById("product-page-articles-list-container");
    let relatedTitle = document.getElementById("SectionHeader__Heading");
    // document.getElementById("related-articles-title").innerHTML = related_article_title;

    for (let i = 0; i < article.length; i++){
      let obj = article[i];

      let divGridCellElement = document.createElement("div");   
      // add 'Carousel__Cell' class below for flickity
      let divGridCellClassesToAdd = ['Grid__Cell', '1/2--tablet', '1/3--lap-and-up' ];
      divGridCellElement.classList.add(...divGridCellClassesToAdd);
      mainContainer.appendChild(divGridCellElement);

      let articleElement = document.createElement("article");
      articleElement.classList.add("ArticleItem");
      divGridCellElement.appendChild(articleElement);

      let aElement = document.createElement("a");
      let aClassesToAdd = ["ArticleItem__ImageWrapper", "AspectRatio", "AspectRatio--withFallback"];
      aElement.classList.add(...aClassesToAdd);
      articleElement.appendChild(aElement);
      aElement.href = `/blogs/${obj.handle}`;
      aElement.style.cssText = `padding-bottom: 58%;--aspect-ratio: 1.7;`;

      let imgElement = document.createElement("img");
      let imgClassesToAdd = ["ArticleItem__Image", "Image--fadeIn", "lazyautosizes", "ls-is-cached", "Image--lazyLoaded"];
      imgElement.classList.add(...imgClassesToAdd);
      imgElement.src = `${obj.image}`;
      aElement.appendChild(imgElement);

      let contentElement = document.createElement("div");
      contentElement.classList.add("ArticleItem__Content");
      articleElement.appendChild(contentElement);
      
      let tagContentElement = document.createElement("span");
      let titleContentElement = document.createElement("a");
      let textContentElement = document.createElement("p");
      let readMoreContentElement = document.createElement("a");

      let tagClassesToAdd = ["ArticleItem__Category", "Heading", "u-h6", "Text--subdued"];
      let titleClassesToAdd = ["ArticleItem__Title", "Heading"];
      let textClassesToAdd = ["ArticleItem__Excerpt", "Text--subdued"];
      let readMoreClassesToAdd = ["ArticleItem__Link", "Link", "btn", "btn-link", "Link--underline"];

      tagContentElement.classList.add(...tagClassesToAdd);
      titleContentElement.classList.add(...titleClassesToAdd);
      textContentElement.classList.add(...textClassesToAdd);
      readMoreContentElement.classList.add(...readMoreClassesToAdd);

      tagContentElement.innerHTML = obj.handle;
      titleContentElement.innerHTML = obj.title;
      textContentElement.innerHTML = obj.excerpt;
      readMoreContentElement.innerHTML = "Read more";
      readMoreContentElement.href = `/blogs/${obj.handle}`;

      contentElement.appendChild(tagContentElement);
      contentElement.appendChild(titleContentElement);
      contentElement.appendChild(textContentElement);
      contentElement.appendChild(readMoreContentElement);
    };



  
    var elem = document.querySelector('.ArticleList--carousel');
    var numOfArticles = elem.querySelectorAll('.Grid__Cell');
    if (numOfArticles.length == 1){
      numOfArticles.style.left = '50%';
      numOfArticles.style.transform = 'translateX(-50%)';
    }
    var flkty = new Flickity( elem, {
      pageDots: false,
      cellAlign: 'left',
      contain: true,
      groupCells: true
    });
  };

}